module.exports = __webpack_public_path__ + "img/logo.74393b1c.png";